<template>
  <el-dialog
    title="投诉商家信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="举报人编号"
      >
        {{agentid}}
      </el-form-item>
      <el-form-item
        label="举报人微信名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
              label="举报类型"
      >
        {{complaint_type}}
      </el-form-item>
      <el-form-item
              label="举报商家"
      >
        {{shop_agentname}}
      </el-form-item>
      <el-form-item
              label="提交时间"
      >
        {{complaint_times}}
      </el-form-item>
      <el-form-item
              label="图片"
      >
        <img :src= "getImgUrl()" style="width: 100px;height: 100px; "/>
      </el-form-item>
      <el-form-item
              label="状态"
      >
        <div v-if="state2=='0'">
          已处理
        </div>
        <div v-else-if="state2=='1'">
          未处理
        </div>
      </el-form-item>

      <el-form-item
              label="审批状态"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.state"
                placeholder="审批"
                width="50"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="terrace_content"
              label="备注"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input  type="textarea"  placeholder="备注信息" v-model="form.terrace_content"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as oneclassService from '@/api/sys/oneclass'
import util from '@/libs/util.js'
export default {
  name: 'oneclassEditForm',
  props: {
    oneclass: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      loading: false,
      dialogVisible: false,
      agentid: '',
      agentname: '',
      shop_agentid: '',
      shop_agentname: '',
      complaint_type: '',
      complaint_img: '',
      complaint_content: '',
      complaint_times: '',
      state2: '',
      typeOptions: [
        {
          value: '0',
          label: '审核通过'
        }, {
          value: '2',
          label: '审核不通过'
        }
      ],
      form: {

      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      let form = {}
      this.form = form
      if (this.oneclass.id) {
        // userService.getUser(this.user.id).then(data => {
        this.agentid = this.oneclass.agentid
        this.agentname = this.oneclass.agentname
        this.shop_agentid = this.oneclass.shop_agentid
        this.shop_agentname = this.oneclass.shop_agentname
        this.complaint_type = this.oneclass.complaint_type
        this.complaint_img = this.oneclass.complaint_img
        this.complaint_content = this.oneclass.complaint_content
        this.complaint_times = this.oneclass.complaint_times
        this.state2 = this.oneclass.state
        this.formEdit = true
      }
    },
    getImgUrl () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.complaint_img
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          var formData = new FormData() // 声明一个FormData对象
          // formData.append('file', this.files, this.fileName);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名

          formData.append('state', this.form.state)
          formData.append('terrace_content', this.form.terrace_content)
          formData.append('id', this.oneclass.id)
          this.loading = true
          oneclassService
            .saveComplaint(formData)
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
